module.exports = __webpack_public_path__ + "img/index-slide-11.16834223.png";